<template>
    <div>
        <rednax-datatable ref="contacttable" :url="'/vue/sales/crm/contact'" :columns="contact_columns" :filter="contact_filter" @updateFilter="contact_filter=$event" :per-page="300" @rowclick="rowClick" history>
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="contact_filter.search" class="form-control">
                </div>
                <div class="col-lg-3">
                </div>
                <div class="col-lg-6 text-right">
                    <button type="button" class="btn btn-primary btn-labeled btn-labeled-left" @click="openContactModal(0)"><b><i class="icon-plus3"></i></b>Skapa ny</button>
                </div>
            </div>
        </rednax-datatable>

        <div id="modal_contact" class="modal fade" data-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="contact">
                    <div class="modal-header">
                        <h5 v-if="contact.id>0" class="modal-title">{{ contact.name }}</h5>
                        <h5 v-else class="modal-title">Ny kontakt</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="saveContact">
                            <contact-form v-model="contact" :strings="strings" :companies="companies" ref="contactform"></contact-form>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="mr-auto">
                            <limitless-button ref="btndeletecontact" type="button" btn-class="btn-danger" icon="icon-cross2" @click="deleteContact" :busy="contact_busy">RADERA</limitless-button>
                        </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        <limitless-button ref="btnsavecontact" type="button" @click="saveContact" :busy="contact_busy" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Kontakt</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <i style="color:red;">Kunde ej ladda data</i>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import ContactForm from '@app/pages/sales_crm/partials/ContactForm';

export default {
    name: 'SalesCrmContacts',
    components: {
        ContactForm,
        RednaxDatatable,
        LimitlessButton,
    },
    props: {
        users: {
            type: Array,
            default() {
                return [];
            },
        },
        companies: {
            type: Object,
            default() {
                return {};
            },
        },
        strings: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data: () => ({
        contact_busy: false,
        contact: null,
        contact_filter: {
            search: '',
        },
        contact_columns: [
            {
                header: '<i class="icon-star-full2"></i>',
                data: 'is_important',
                sortable: true,
                render(row) {
                    return (row.is_important ? '<i class="icon-star-full2 text-orange-400"></i>' : '');
                },
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Befattning',
                data: 'work_title',
                sortable: true,
            },
            {
                header: 'Företag',
                data: 'company_name',
                sortable: true,
            },
            {
                header: 'E-post',
                data: 'email',
                sortable: true,
            },
            {
                header: 'Tel. nr',
                data: 'phone',
                sortable: true,
            },
            {
                header: 'Mob. nr',
                data: 'mobile_phone',
                sortable: true,
            },
        ],
        select_contact_dates: [
            { id: 'today', text: 'Aktuellt idag' },
            // {id:'week', text:'Denna vecka'},
            // {id:'next_week', text:'Nästa vecka'},
        ],
        datepickersettings: {
            singleDatePicker: true,
            showISOWeekNumbers: true,
            timePicker: true,
            timePicker24Hour: true,
            locale: {
                format: 'YYYY-MM-DD hh:mm',
                separator: ' - ',
                applyLabel: 'Välj',
                cancelLabel: 'Avbryt',
                fromLabel: 'Från',
                toLabel: 'Till',
                customRangeLabel: 'Custom',
                weekLabel: 'V',
                daysOfWeek: [
                    'Sö',
                    'Må',
                    'Ti',
                    'On',
                    'To',
                    'Fr',
                    'Lö',
                ],
                monthNames: [
                    'Januari',
                    'Februari',
                    'Mard',
                    'April',
                    'Maj',
                    'Juni',
                    'Juli',
                    'Augusti',
                    'September',
                    'Oktober',
                    'November',
                    'December',
                ],
                firstDay: 1,
            },
            // "startDate": "",
            // "endDate": ""
        },
    }),
    methods: {
        rowClick(contact) {
            this.openContactModal(contact.id);
        },
        openContactModal(contactId) {
            const vm = this;
            vm.contact_busy = true;
            apiClient.get(`/vue/sales/crm/contact/${contactId}`)
                .then((response) => {
                    vm.contact = response.data;
                    // eslint-disable-next-line no-undef
                    $('#modal_contact').modal('show');
                })
                .finally(() => {
                    vm.contact_busy = false;
                });
        },
        async saveContact() {
            const vm = this;
            const isValid = await vm.$refs.contactform.validate();
            if (isValid) {
                vm.contact_busy = true;
                await apiClient.post(`/vue/sales/crm/contact/${vm.contact.id}`, vm.contact)
                    .then((response) => {
                        vm.contact = response.data;
                        vm.$refs.btnsavecontact.triggerSaved();
                        vm.$refs.contacttable.reload();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            vm.$refs.contactform.setErrors(parsederror);
                        }
                        vm.$refs.btnsavecontact.triggerFailed();
                    })
                    .finally(() => {
                        vm.contact_busy = false;
                    });
            } else {
                vm.$refs.btnsavecontact.triggerFailed();
            }
        },
        async deleteContact() {
            const vm = this;
            // eslint-disable-next-line no-undef
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    vm.contact_busy = true;
                    await apiClient.delete(`/vue/sales/crm/contact/${vm.contact.id}`)
                        .then(() => {
                            vm.$refs.btndeletecontact.triggerSaved();
                            vm.$refs.contacttable.reload();
                            // eslint-disable-next-line no-undef
                            $('#modal_contact').modal('hide');
                        })
                        .catch(() => {
                            vm.$refs.btndeletecontact.triggerFailed();
                        })
                        .finally(() => {
                            vm.contact_busy = false;
                        });
                }
            });
        },
    },
};
</script>

<style scoped>

</style>
